<template>
    <div>
        <app-header></app-header>
        <div  class="container">
            <div class="row">
                <div class="col-sm-12 mt-5">
                    <div class="alert primary">
                        <div class="alert-text">
                            <div class="font-md">
                                <span class="fw-bold">{{$t("transactionData.transaction")}}:</span> {{txHash}}
                                <Icon type="ios-copy-outline" :title="$t('common.copy')" @click="copyTxHash" :data-clipboard-text="txHash" color="primary--text" class="txHash pointer"></Icon>
                            </div>
                            <div class="font-md">
                                <span class="fw-bold">{{$t("transactionData.contract")}}:</span>
                                <span v-show="transaction.contractAddress != ''">
                                    {{transaction.contractAddress}}
                                    <Icon type="ios-copy-outline" :title="$t('common.copy')" @click="copyContract" :data-clipboard-text="transaction.contractAddress" class="contract pointer" color="primary--text"></Icon>
                                </span>
                                <span v-show="transaction.contractAddress == ''">
                                    {{transaction.to}}
                                    <Icon type="ios-copy-outline" :title="$t('common.copy')" @click="copyContract" :data-clipboard-text="transaction.to" class="contract pointer" color="primary--text"></Icon>
                                </span>
                                
                                <!-- <span @mouseover="generateQRCode" @mouseout="hideQRCode">
                                    <Icon class="fas fa-qrcode pointer" size="16"></Icon>
                                </span> -->
                            </div>
                        </div>
                        <div v-show="isShowQRCode" id="qrcode" class="qrcode">
                            <canvas id="canvas" width="200px" height="200px;"></canvas>
                        </div>
                    </div>
                </div>
                <div class="container mt-4 row">
                    <div class="col-sm-3 fw-bold font-sm">
                        {{$t("transactionData.txHash")}}
                    </div>
                    <div class="col-sm-9 mb-3">
                        {{txHash}}
                    </div>
                    <div class="col-sm-3 fw-bold font-sm">
                        {{$t("transactionData.blockHeight")}}
                    </div>
                    <div class="col-sm-9 mb-3">
                        {{transaction.blockNumber}}
                    </div>
                    <div class="col-sm-3 fw-bold font-sm">
                        {{$t("transactionData.time")}}
                    </div>
                    <div class="col-sm-9 mb-3">
                        {{timeStampToTime(transaction.timeStamp)}}
                    </div>
                    <div class="col-sm-3 fw-bold font-sm">
                        {{$t("transactionData.from")}}
                    </div>
                    <div class="col-sm-9 mb-3 primary--text">
                        {{transaction.from}}
                    </div>
                    <div class="col-sm-3 fw-bold font-sm">
                        {{$t("transactionData.to")}}
                    </div>
                    <div class="col-sm-9 mb-3">
                        {{$t("transactionData.contract")}}
                        <span v-show="transaction.contractAddress != ''" class="primary--text">
                            {{transaction.contractAddress}}
                        </span>
                        <span v-show="transaction.contractAddress == ''" class="primary--text">
                            {{transaction.to}}
                        </span>
                    </div>
                    <div class="col-sm-3 fw-bold font-sm">
                        {{$t("transactionData.tokensTransfered")}}
                    </div>
                    <div class="col-sm-9 mb-3">
                        <span>{{$t("transactionData.from")}} 
                        <span class="primary--text">
                            <v-tooltip bottom>
                                <span slot="activator">
                                    {{transaction.from > 18 ? transaction.from.substring(0,18) + '...' : transaction.from}}
                                </span>
                                <span>{{transaction.from}}</span>
                            </v-tooltip>
                        </span> {{$t("transactionData.to")}} 
                        <span class="primary--text">
                            <v-tooltip bottom>
                                <span slot="activator">
                                    {{subToHash(transaction.input) > 18 ? subToHash(transaction.input).substring(0,18) + '...' : subToHash(transaction.input)}}
                                </span>
                                <span>{{subToHash(transaction.input)}}</span>
                            </v-tooltip>
                        </span> for
                        {{getQuantity(transaction.input)}} ERC-20(IOB Token)
                         </span>
                    </div>
                    <div class="col-sm-3 fw-bold font-sm">
                        {{$t("transactionData.gasLimit")}}
                    </div>
                    <div class="col-sm-9 mb-3">
                        {{transaction.gas}}
                    </div>
                     <div class="col-sm-3 fw-bold font-sm">
                        {{$t("transactionData.gasUsedByTransaction")}}
                    </div>
                    <div class="col-sm-9 mb-3">
                        {{transaction.gasUsed}}
                    </div>
                    <div class="col-sm-3 fw-bold font-sm">
                        {{$t("transactionData.gasPrice")}}
                    </div>
                    <div class="col-sm-9 mb-3">
                        {{numberToString(transaction.gasPrice)}}
                    </div>
                    <div class="col-sm-3 fw-bold font-sm">
                        {{$t("transactionData.nonceAndPosition")}}
                    </div>
                    <div class="col-sm-9 mb-3">
                        <span>{{transaction.nonce}}|<span>{</span>{{transaction.transactionIndex}}<span>}</span></span>
                    </div>
                </div>
        </div>
</div>
</div>
</template>

<script>
import Vue from 'vue'
import config from '../../config.js'
import Clipboard from 'clipboard'
import QRCode from 'qrcode'
export default {
    data(){
        return{
                txHash: this.$route.params.txHash,          //交易哈希地址
                transaction: {},                            //交易对象
                isShowQRCode: false,                        //是否显示二维码
            }
        },
        computed: {

        },
        created(){
            this.getTransactionByTxHash();
        },
        mounted(){
        },
        watch:{
            //监听路由的txHash变化之后就重新加载页面
            $route(){
                this.txHash = this.$route.params.txHash;
            },
            txHash(){
                this.getTransactionByTxHash();
            }
        },
        methods: {
            getTransactionByTxHash(){
                this.transaction = JSON.parse(sessionStorage.getItem('transaction'));
            },
            timeStampToTime(timeStamp){
                return timeStampToTime(timeStamp);
            },
            //截取目标hash值
            subToHash(input){
                let to = '0x' + input.substring(34, 74);
                return to;
            },
            numberToString(number){
                let num = number / 1E18;
                // let str = ( num + "" ).toString();
                return num;
            },
            //从input中截取出16进制数的数量并进行转换为10进制
            getQuantity(input){
                let sixteen = input.substring(74, 138);
                var ten = parseInt(sixteen,16);
                return ten / 1E18;
            },
            //复制Txhash
            copyTxHash(){
                var clipboard = new Clipboard('.txHash');
                clipboard.on('success', e => {
                    this.$Message.success(this.$t("common.copySuccess"));
                    // 释放内存
                    clipboard.destroy();
                })
                clipboard.on('error', e => {
                  // 该浏览器不支持自动复制
                  this.$Message.error(this.$t("common.copyFailure"));
                  // 释放内存
                  clipboard.destroy();
              })
            },
            //复制钱包地址
            copyContract(){
                var clipboard = new Clipboard('.contract');
                clipboard.on('success', e => {
                  this.$Message.success(this.$t("common.copySuccess"));
                  // 释放内存
                  clipboard.destroy();
              })
                clipboard.on('error', e => {
                  // 该浏览器不支持自动复制
                  this.$Message.error(this.$t("common.copyFailure"));
                  // 释放内存
                  clipboard.destroy();
              })
            },
            //生成钱包地址二维码
            generateQRCode(event){
                var canvas = document.getElementById('canvas');
                canvas.style.position = 'fixed';
                canvas.style.top = event.clientY + 20;
                canvas.style.left = event.clientX + 20;
                this.isShowQRCode = !this.isShowQRCode;
                QRCode.toCanvas(canvas, this.transaction.contractAddress, function (error) {
                })
            },
            //隐藏二维码
            hideQRCode(){
                this.isShowQRCode = false;
            },
        },
    }
    </script>


// WEBPACK FOOTER //
// TransactionData.vue?727cb89a